<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-7>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("dashboard.detail") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-spacer></v-spacer>
                  <v-flex xs7 lg4 mr-6>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <template>
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="GroupDetail"
                    :search="Search"
                  >
                    <template v-slot:[`item.DetailSend`]="{ item }">
                      <v-btn
                        color="#077893"
                        dark
                        small
                        rounded
                        @click="Fn_ViewDetail(item)"
                        >{{ $t("consentlist.detail") }}</v-btn
                      >
                    </template>
                    <template v-slot:[`item.Email`]="{ item }">
                      <div v-if="item.Email === ''">-</div>
                      <div v-else>
                        {{ item.Email }}
                      </div>
                    </template>
                    <template v-slot:[`item.SendAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.SendAt }}
                      </div>
                      <div v-else>
                        {{ item.SendAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <v-chip
                        v-if="item.Status === 'ยินยอม'"
                        :color="Fn_GetColor(item.Status)"
                        class="my-1"
                      >
                        {{ $t("dashboard.statusapp") }}</v-chip
                      >
                      <v-chip
                        v-else-if="item.Status === 'ปฏิเสธ'"
                        :color="Fn_GetColor(item.Status)"
                        class="my-1"
                      >
                        {{ $t("dashboard.statusreject") }}
                      </v-chip>
                      <v-chip
                        v-else
                        :color="Fn_GetColor(item.Status)"
                        class="my-1"
                        >{{ $t("dashboard.statuspen") }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </template>
              </v-card-text>
            </v-card>
            <v-overlay :value="loadingDownloadData">
              <img
                width="100"
                :src="require('@/assets/img/magnifier-zoom-search.gif')"
              />
              <div class="text-center">{{ $t("overlay.load") }}</div>
            </v-overlay>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      Search: "",
      GroupDetail: [],
      loadingDownloadData: true,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "start",
          sortable: false,
          value: "no",
          align: "center",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "SourceSystem",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.name"),
          value: "Name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.email"),
          value: "Email",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.create"),
          value: "SendAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.detailtable"),
          value: "DetailSend",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.status"),
          value: "Status",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.testID = [];
    this.Fn_GetId();
    this.Fn_GetDetail();
  },
  methods: {
    Fn_GetId() {
      var test = this.$cookies.get("IDgroup");
      this.testID = test;
    },
    Fn_GetDetail() {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        Type: "Group",
        Consent: this.testID,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/Detail/Consent",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.GroupDetail = response.data.Message;
            var index = 0;
            for (var item of response.data.Message) {
              index += 1;
              item.no = index;
            }
            // this.GroupEmail = response.data.Message[0].Email;
            // this.GroupName = response.data.Message[0].Name;
            // this.GroupSendAt = response.data.Message[0].SendAt;
            // this.GroupStatus = response.data.Message[0].Status;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ViewDetail(val) {
      this.$router.push("/group-dashboard-detail");
      this.$store.dispatch("SET_DATA_GROUP_DASHBOARD", val);
    },
    Fn_BackIndex() {
      this.$router.push("/consent-dashboard-detail");
    },
    Fn_GetColor(Status) {
      if (Status === "ยินยอม") return "teal lighten-5 teal--text";
      else if (Status === "ปฏิเสธ") return "red lighten-5 red--text";
      else return "orange lighten-5 orange--text";
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
